<template>
  <validation-provider
    ref="fileInput"
    v-slot="{ errors }"
    :rules="rules"
    :vid="vid"
    :name="name">
    <file-uploader
      :value="_value"
      :preview-image-class="previewImageClass"
      @input="onInputFile" />
    <BaseErrorMessage :errors="[...errors, ...responseFieldErrors]" />
  </validation-provider>
</template>

<script>
import FileUploader from '@/components/parts/FileUploader.vue'
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
export default {
  components: {
    FileUploader,
    BaseErrorMessage
  },
  props: {
    value: {
      type: [String, File],
      default: null
    },
    name: {
      type: String,
      default: undefined
    },
    responseErrors: {
      type: Object,
      default: null
    },
    vid: {
      type: String,
      default: null
    },
    rules: {
      type: String,
      default: 'file_size'
    },
    previewImageClass: {
      type: String,
      default: undefined
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    responseFieldErrors() {
      return this.responseErrors?.[this.vid] || []
    }
  },
  methods: {
    onInputFile(file) {
      this._value = file

      if (file == null) {
        this.$refs.fileInput.reset()
      }
    }
  }
}
</script>

<style>

</style>